<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">满减活动</p>
		</sub-ibox-title>
		<z-tabbar :list-obj="tabbarList"></z-tabbar>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'Promotions',
		data() {
			return {
				tabbarList: [{
					title: '活动列表',
					routeName: 'promotionList'
				}]
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Index.vue?31200202